import { render } from "./InfoView.vue?vue&type=template&id=52a4e061"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__